const BASE_URL = 'https://taila.fr'
export default BASE_URL

